import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import RequisitionApprovalsComp from './RequisitionApprovalsComp';

function RequisitionApprovals() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <RequisitionApprovalsComp />
      </div>
    </div>
  );
}

export default RequisitionApprovals;
